import React from "react";

export const LeftIcon = () => {
  return (
    <div>
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width="64"
        height="65"
        viewBox="0 0 64 65"
        fill="none">
        <path
          d="M32 16.5L34.86 19.286L23.7 30.5H48V34.5H23.7L34.86 45.646L32 48.5L16 32.5L32 16.5Z"
          fill="white"
        />
        <path
          d="M32 60.5C37.5379 60.5 42.9514 58.8578 47.556 55.7812C52.1605 52.7045 55.7494 48.3315 57.8686 43.2151C59.9879 38.0988 60.5424 32.469 59.462 27.0375C58.3816 21.606 55.7148 16.6169 51.799 12.701C47.8831 8.78515 42.894 6.11841 37.4625 5.03802C32.031 3.95764 26.4012 4.51213 21.2849 6.63139C16.1685 8.75064 11.7955 12.3395 8.71884 16.944C5.64216 21.5486 3.99999 26.9621 3.99999 32.5C4.00846 39.9235 6.96117 47.0405 12.2104 52.2896C17.4595 57.5388 24.5765 60.4915 32 60.5ZM32 8.50001C36.7467 8.50001 41.3869 9.90759 45.3337 12.5447C49.2805 15.1819 52.3566 18.9302 54.1731 23.3156C55.9896 27.701 56.4649 32.5266 55.5388 37.1822C54.6128 41.8377 52.327 46.1141 48.9706 49.4706C45.6141 52.827 41.3377 55.1128 36.6822 56.0389C32.0266 56.9649 27.201 56.4896 22.8156 54.6731C18.4302 52.8566 14.6819 49.7805 12.0447 45.8337C9.40757 41.8869 7.99999 37.2468 7.99999 32.5C8.0074 26.1371 10.5383 20.0369 15.0376 15.5376C19.5369 11.0384 25.6371 8.50742 32 8.50001Z"
          fill="white"
        />
      </svg>
    </div>
  );
};
